// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LayoutFilters_layout__igM4l {
  height: 100vh;
}
@media (min-width: 480px) {
  .LayoutFilters_layout__igM4l {
    height: auto;
  }
}

.LayoutFilters_main__wOtyL {
  margin: 20px;
}

.LayoutFilters_drawer__gmk8P {
  background: #fff;
  padding-top: 20px;
}

.LayoutFilters_mainFilters__e0Y\\+L {
  display: flex;
}
@media (min-width: 320px) {
  .LayoutFilters_mainFilters__e0Y\\+L {
    display: none;
  }
}
@media (min-width: 720px) {
  .LayoutFilters_mainFilters__e0Y\\+L {
    display: none;
  }
}
@media (min-width: 1023px) {
  .LayoutFilters_mainFilters__e0Y\\+L {
    display: flex;
  }
}

.LayoutFilters_grayButton__fs9\\+I {
  background-color: #d9d9d9 !important;
  color: #838383 !important;
}
@media (min-width: 1023px) {
  .LayoutFilters_grayButton__fs9\\+I {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/LayoutFilters/LayoutFilters.module.scss","webpack://./src/_common/scss/_media.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;ACaI;EDbJ;IAII,YAAA;EAAF;AACF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;ACTI;EDQJ;IAII,aAAA;EACF;AACF;ACNI;EDAJ;IAQI,aAAA;EAEF;AACF;ACPI;EDJJ;IAYI,aAAA;EAGF;AACF;;AAAA;EACE,oCAAA;EACA,yBAAA;AAGF;ACjBI;EDYJ;IAII,aAAA;EAKF;AACF","sourcesContent":["@import '@common/scss/_media';\n\n.layout {\n  height: 100vh;\n\n  @include media(xs) {\n    height: auto;\n  }\n}\n\n.main {\n  margin: 20px;\n}\n\n.drawer {\n  background: #fff;\n  padding-top: 20px;\n}\n\n.mainFilters {\n  display: flex;\n\n  @include media(xss) {\n    display: none;\n  }\n\n  @include media(sm) {\n    display: none;\n  }\n\n  @include media(md) {\n    display: flex;\n  }\n}\n\n.grayButton {\n  background-color: #d9d9d9 !important;\n  color: #838383 !important;\n  @include media(md) {\n    display: none;\n  }\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `LayoutFilters_layout__igM4l`,
	"main": `LayoutFilters_main__wOtyL`,
	"drawer": `LayoutFilters_drawer__gmk8P`,
	"mainFilters": `LayoutFilters_mainFilters__e0Y+L`,
	"grayButton": `LayoutFilters_grayButton__fs9+I`
};
export default ___CSS_LOADER_EXPORT___;
